module.exports = __webpack_public_path__ + "static/img/3.de730620.png";